module.exports = __webpack_public_path__ + "img/h2s.629f2f32.svg";